import { ASSIGNMENTS } from 'constants/actionTypes';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import DateFormat from 'constants/date_format';
import moment from 'moment';

export const selectAllAssignment = checked => ({
  type: ASSIGNMENTS.ACTION.SELECT_ALL,
  checked,
});

export const selectSingleAssignment = (checked, id) => ({
  type: ASSIGNMENTS.ACTION.SELECT_SINGLE,
  checked,
  id,
});

export const deleteAssignment = id => ({
  type: ASSIGNMENTS.ACTION.DELETE_ASSIGNMENT,
  id,
});

export const deleteBulkAssignment = () => ({
  type: ASSIGNMENTS.ACTION.DELETE_BULK_ASSIGNMENT,
});

export const updateBulkDueDate = date => ({
  type: ASSIGNMENTS.ACTION.UPDATE_BULK_DATE,
  date,
});

export const updateDueDate = (date, id) => ({
  type: ASSIGNMENTS.ACTION.UPDATE_DATE,
  date,
  id,
});

export const removeAssignment = (id, url) => {
  return dispatch => {
    request.delete(url).then(() => dispatch(deleteAssignment(id)));
  };
};

export const removeBulkAssignment = assignmentId => {
  return (dispatch, getState) => {
    const { selectedIds } = getState().assignDirectly;
    request
      .post(
        routes.ASSIGNMENTS.BULK_DESTROY,
        {
          selected_ids: selectedIds,
          lesson_id: assignmentId,
          path_id: '',
          due_by: '',
          button: '',
        },
        { dataType: 'json' },
      )
      .done(() => {
        dispatch(deleteBulkAssignment());
      });
  };
};

export const setBulkDate = date => {
  return (dispatch, getState) => {
    const dateFormat = date
      ? moment(date).format(DateFormat.fixed.DB_DATE)
      : '';
    const { selectedIds } = getState().assignDirectly;
    const data = {
      selected_ids: selectedIds,
      lesson_id: '',
      path_id: '',
      due_by: dateFormat,
    };
    request.postJSON(routes.ASSIGNMENTS.BULK_UPDATE, data).done(() => {
      dispatch(updateBulkDueDate(date));
    });
  };
};

export const updateDate = (date, id) => {
  return dispatch => {
    const dateFormat = date
      ? moment(date).format(DateFormat.fixed.DB_DATE)
      : '';
    const data = {
      _method: 'patch',
      due_by: dateFormat,
    };
    request.patchJSON(routes.ASSIGNMENTS.SET_DUE_DATE(id), data).done(() => {
      dispatch(updateDueDate(date, id));
    });
  };
};
